module.exports = __webpack_public_path__ + "static/media/Workhorse_Logo.760da1e1.png";